import { useEffect, useState } from "react";
import Cards from "./Cards";

const Shop = () => {

    const [products, setProducts] = useState([])

    const refreshProducts = function() {
        const url = restUrl + '/wp-json/membersync/licensing/v1/org/shop/products'
        const nonce = restNonce

        fetch(url, {
            method: 'POST',
            body: JSON.stringify({
            }),
            headers:{
                'X-WP-Nonce': nonce,
                'Content-type': 'application/json'
            }
        }).then(resp => {
            return resp.json()
        })
        .then((json) => {
            setProducts([...json.response])
        })
    }

    useEffect(() => {
        refreshProducts()
    }, [])

    return (
        <>
            { currentUserIsTeamsOwner ?
                <div>
                    
                    <div> 
                        <Cards 
                            products={products}
                        />
                    </div>
                </div>
                
                : "You're not the owner of any team or you're not login so you can't have access to this content."
            }
        </>
    );
};

export default Shop;